import { render, staticRenderFns } from "./SavedViews.vue?vue&type=template&id=75f24d88&"
import script from "./SavedViews.vue?vue&type=script&lang=js&"
export * from "./SavedViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports